module.exports = __webpack_public_path__ + "img/pop_icon_LARIX@3x.a95fc3cf.png";